import UIFetchService from '../Service/UIFetchService';
import auth from "../Service/AuthFetchService";
import { parseUrlSearch } from '../Service/Utils';

import React from 'react';
import {
    Row, Col
} from 'antd';
import {

} from '@ant-design/icons';

class QueryingExportingView extends React.Component {
    constructor() {
        super();
        this.state = {
            error: '',
            pending: false,
            url: '',
            md5Digest: '',
        };
    }

    render() {
        return <>
            <div style={{ height: 200 }}></div>
            <Row justify='center'>
                <Col>
                    <h2>下载链接(有效期最多1小时):</h2>
                </Col>
                <Col style={{ padding: '2px 0 0 10px', fontSize: 20 }}>
                    {this.state.pending
                        ? <span>生成中...</span>
                        : <a href={this.state.url}>点击此处下载</a>}
                </Col>
            </Row>
            <Row justify='center'>
                <Col>
                    <h2>文件MD5 Hash:</h2>
                </Col>
                <Col style={{ padding: '2px 0 0 10px', fontSize: 20 }}>
                    {this.state.pending
                        ? <span>生成中...</span>
                        : <code style={{ color: '#722ed1' }}>{this.state.md5Digest}</code>}
                </Col>
            </Row>
        </>
    }

    async componentDidMount() {
        const params = parseUrlSearch(window.location.search);
        if (params.shared_code === undefined) {
            this.setState({ error: '找不到指定的文件' });
            return;
        }

        this.setState({ pending: true });
        setTimeout(async () => {
            const file = await UIFetchService.get(`/api/v1/querying_exporting/download_url?sharedCode=${params.shared_code}`);
            if (file) {
                this.setState({ ...file, pending: false });
            } else {
                this.setState({ error: '找不到指定的文件', pending: false });
            }
        }, 2000);
        
        auth.appendLog(`数据导出页面`);
    }
};


export default QueryingExportingView;